import { Component, ChangeDetectorRef, ViewChild, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { BaseAppMComponent } from '../../shared/base-components/base-app-m.component';
import { GlobalsService } from '../../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '../../dqoi/state/dqoi-reference-data.query';
import { SaveMode } from '../../shared/enums/SaveMode';
import { CommonFunctions } from '../../shared/static/common-functions';
import * as _ from 'lodash';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { GItem } from '../../shared/models/GItem';
import { Subscription } from 'rxjs';
import { CommonParam } from '../../shared/models/CommonParam';
import { DateFunctions } from '../../shared/static/date-functions';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { DispatchQVBus } from '../../shared/models/DispatchQVBus';
import { DispatchPage } from '../../shared/models/DispatchPage';
import { AdditionalDispatchQVData } from '../../shared/models/AdditionalDispatchQVData';
import { DispatchAssignmentBus } from '../../shared/models/DispatchAssignmentBus';
import { CommonValues } from '../../shared/static/CommonValues';
import { StatusUpdateBus } from '../../shared/models/StatusUpdateBus';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { DispatchMessageInfo } from '../../shared/models/DispatchMessageInfo';
import { CustomerService } from '../../shared/services/customer.service';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { EmpNoteComponent } from '../../shared/components/emp-note/emp-note.component';
import { PersonSel } from '../../shared/models/PersonSelBus';
import { DispatchThirdPartyHistoryDialogComponent } from '../../dispatches/dispatch-third-party-history-dialog/dispatch-third-party-history-dialog.component';
import { DispatchChangeStatusDialogComponent } from '../../dispatch-qv/dispatch-change-status-dialog/dispatch-change-status-dialog.component';
import { DispatchChangeAssignmentDialogComponent } from '../../dispatch-qv/dispatch-change-assignment-dialog/dispatch-change-assignment-dialog.component';
import { GGItem } from '@app/cp/shared/models/GGItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'dispatch-qv-dispatch-board',
    templateUrl: './dispatch-qv-dispatch-board.component.html',
    styleUrls: ['./dispatch-qv-dispatch-board.component.scss']
})
export class DispatchQVDispatchBoardComponent extends BaseAppMComponent<DispatchQVBus, DispatchesService, AdditionalDispatchQVData,  DispatchPage> {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_data: DispatchesService, qry_rd: DQOIReferenceDataQuery, private cd: ChangeDetectorRef, private sanitizer: DomSanitizer, private svc_cust: CustomerService) {
        super(globals, featureFlagService, qry_rd);
        this.svc_data = svc_data;
        this.addtlDataClass = "AdditionalDispatchQVData";
        this.pageData = new DispatchPage(svc_data);
        this.saveMode = SaveMode.individual;
        this.appCode = "Field Service Supervisor View"
        this.data = this.createNew(null);
        this.getBlankAddtlData();
    }
    override ngOnInit() {
        this.getRankData();
        super.ngOnInit();
    }
    active: boolean = false;
    @Output() closed = new EventEmitter<any>();
    @Output() openAssignment = new EventEmitter<any>();
    @Output() closeThisWindow = new EventEmitter<any>();

    @Input() svcMgrIds: any;

    sublings: GItem[];
    subPersons: PersonSel[];
    rankData: any;
    subs_dataEmp: Subscription;
    subs_statusChangeCheck: Subscription;
    repairCatWithBlank: GItem[]; //this.referenceData.getGItemListWithBlank(referenceData.repairCat);
    @ViewChild('dispatchChangeStatusDialog') public dispatchChangeStatusDialog: DispatchChangeStatusDialogComponent;
    @ViewChild('dispatchChangeAssignmentDialog') public dispatchChangeAssignmentDialog: DispatchChangeAssignmentDialogComponent;
    @ViewChild('dispatchThirdPartyHistoryDialog') public dispatchThirdPartyHistoryDialog: DispatchThirdPartyHistoryDialogComponent;
    @ViewChild('empNote') public empNoteDialog: EmpNoteComponent;
    isConstruction: boolean = false;

    showDispatchViewHistoryDialog: boolean = false;

    changeStatus() {

        this.dispatchChangeStatusDialog.show(null);

    }
    viewDispatchHistory() {
        this.showDispatchViewHistoryDialog = true;
    }
    assignTech() {
        this.openAssignment.emit();
    }
    addEmployeeNote() {

        this.empNoteDialog.show(this.globals.user.personId);

    }
    closeWindow() {
        this.closeThisWindow.emit(null);

    }
    clear() {
        super.clear();
        this.logo = null;
    }
    public windowTop: number = 0;
    public windowLeft: number = 0;

    customSetId() {
    }
    viewHistory() {

        this.dispatchThirdPartyHistoryDialog.openHistory(this.id);

    }
    createNew(data: DispatchQVBus): DispatchQVBus {
        let dataObj: DispatchQVBus = new DispatchQVBus(data);
        return dataObj;
    }
    refreshMessage(event: any) {
        this.pageData.getDispatchAttachments(this.id);

    }
    getData() {
        if (CommonFunctions.hasGuidValue(this.id)) {
            if (this.mainTab && this.mainTab.tabs && this.mainTab.tabs.length > 1) {
                this.mainTab.selectTab(1);
            }
            this.compLoader.cpLoader = true;
            this.pageData.clear();
            this.subs_data = this.svc_data.getDispatchQV(this.id).subscribe((info: BaseMessageInfo) => {
                this.compLoader.cpLoader = false;
                if (!info.saveError) {
                    this.isConstruction = info.primaryReturn.isConstruction;
                    this.accountClasses;
                    this.setData(info.primaryReturn);
                    super.getData();
                }
            });
        }
    }

    get accountClasses(): GGItem[] {
        let classes: GGItem[] = [];
        if (this.hasReferenceData) {
            classes = this.isConstruction ? this.referenceData.accountClassesConstruction : this.referenceData.accountClassesService;
        }
        return classes;
    }

    get estimatedInvoiceAmount(): number {
        return this.hasAddtlData ? this.addtlData.estimatedInvoiceAmount : 0;
    }
    get notToExceed(): number {
        return this.hasData ? this.data.notToExceed : 0;
    }
    get exceedsNTE(): boolean {
        return this.estimatedInvoiceAmount > this.notToExceed ? true : false;
    }

    getAddtlData() {
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        this.subs_dataAddInfo = this.svc_data.getAdditionalDispatchDataQV(this.id).subscribe((info: BaseMessageInfo) => {
            this.addtlData = new AdditionalDispatchQVData(info.dcValues);
        });
        CommonFunctions.unsubscribe(this.subs_dataEmp);
        let se: CommonParam = new CommonParam();
        se.addParam("PersonId", this.globals.user.personId);

        this.subs_dataEmp = this.svc_data.getAssignableTechsForFldSvcSupQV(se).subscribe((info: BaseMessageInfo) => {
            this.sublings = info.primaryReturn;
            this.subPersons = [];
            for (var i = 0; i < this.sublings.length; i++) {

                let index = this.referenceData.personsSel.findIndex((element) => { return element.value === this.sublings[i].value });
                if (index >= 0) {
                    if (this.referenceData.personsSel[index].isActive) {
                        this.subPersons.push(this.referenceData.personsSel[index])

                    }

                }
            }
            this.subPersons.sort((a, b) => (a.description > b.description) ? 1 : -1)
        });

        this.pageData.getDispatchNotes(this.id);

        this.svc_cust.getLogo(this.data.customerId).subscribe(blob => {
            this.logo = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));

        });
    }
    getRankData(){
        this.svc_data.GetDispatchRankOrders().subscribe(data=>{
            if(data) this.rankData = data.primaryReturn;
         })
    }
    logo: any;
    get hasLogo(): boolean {
        return CommonFunctions.hasValue(this.logo);
    }
    onTabSelect(e: SelectEvent) {

        if (e.title === 'Dispatch History') {
            this.pageData.getStatusHistory(this.id);
        }
        else if (e.title === 'Parts Used' && !this.pageData.hasPartsQV) {
            this.pageData.getPartsQV(this.id);

            this.pageData.getDispatchTrucks(this.id);
        }
        else if (e.title === 'Equipment' && !this.pageData.hasEquipmentSvcd) {
            this.pageData.getEquipmentSvcdOnly(this.id);
        }
        else if (e.title === 'Assets' && !this.pageData.hasAssets) {
            this.pageData.getAssets(this.id);
        }
        else if (e.title === 'Attachments' && !this.pageData.hasAttachments) {
            this.pageData.getDispatchAttachments(this.id);
        }
        else if (e.title === 'Labor' && !this.pageData.hasLaborQV) {
            this.pageData.getLaborQV(this.id);
        }
        else if (e.title === 'Kudos & Opportunity' && !this.pageData.hasKudosAndOpportunities) {
            this.pageData.getKudosAndOpportunities(this.id);
        }
    }
    showMoreHistory() {
        let url: string = "/dispatch/history/" + this.data.customerId + "/" + this.data.locationId;
        window.open(url, "_blank");

    }
    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'dispatchId': new UntypedFormControl(),
        'dispatchNumber': new UntypedFormControl(),
        'dispatchReason': new UntypedFormControl(),
        'customerName': new UntypedFormControl(),
        'locationName': new UntypedFormControl(),
        'receivedDateTime': new UntypedFormControl(),
        'woNumber': new UntypedFormControl(),
        'poNumber': new UntypedFormControl(),
        'dispatchStatusName': new UntypedFormControl(),
        'accountClassName': new UntypedFormControl(),
        'accountClassId': new UntypedFormControl(),
        'priorityName': new UntypedFormControl(),
        'notToExceed': new UntypedFormControl()
    });
    setForm() {
        this.editForm.patchValue({
            dispatchId: this.data.dispatchId,
            dispatchNumber: this.data.dispatchNumber,
            dispatchReason: this.data.dispatchReason,
            customerName: this.data.customerName,
            locationName: this.data.locationName,
            receivedDateTime: this.data.receivedDateTime,
            woNumber: this.data.woNumber,
            poNumber:this.data.poNumber,
            dispatchStatusName: this.data.dispatchStatusName,
            accountClassName: this.data.accountClassName,
            accountClassId: this.data.accountClassId,
            notToExceed: this.data.notToExceed
        });

    }

    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok) {
            if (data.code == "UpdateDispatchStatus") {
                this.saveDispatchStatus(CommonValues.Dispatch_Dispatched)
            }
            else if (data.code === "ASGNRES") {
                this.subs_data = this.svc_data.closeDispatchAssignments(this.data.dispatchId).subscribe((info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        this.saveSuccess("Assignments Closed");

                    }
                    else {
                        this.saveError(info.message);
                    }
                });
            }
        }
    }

    getCallbackAssignments(id: any) {
        this.svc_data.GetDispatchAssignments(id).subscribe(data => {
        });
    }
    callbackSearch: boolean = false;
    doCallbackSearch(code: string) {
        if (code === "CLEAR") {
            this.setCallback(null, null);
        }
        else {
            this.callbackSearch = true;
        }
    }
    setCallback(id: any, number: string) {
        this.data.callbackId = id;
        this.data.callbackNumber = number;
        this.data.saveCode = "Callback";
        this.saveItem();
        this.getCallbackAssignments(id);
    }
    cpCallbackSelected(value: any) {
        this.callbackSearch = false;
        if (value != null) {
            this.setCallback(value.DispatchId, value.DispatchNumber);
        }
    }
    cpCallbackGoto(number: string) {
        this.callbackId = this.data.callbackId;
    }
    callbackId: any;
    callbackClosed(e: any) {
        this.callbackId = null;
    }

    cpCallbackValidate(value: any) {
    }
    repairCBOChanged(data: GItem) {
        this.data.saveCode = "RepairCat";
        this.data.dispatchRepairCatId = data.value;
        this.saveItem();
    }
    dispProbCodesCBOChanged(data: GItem) {
        this.data.saveCode = "ProblemCode";
        this.data.dispatchProblemCodeId = data.value;
        this.saveItem();
    }
    dispFailureCodesCBOChanged(data: GItem) {
        this.data.saveCode = "FailureCode";
        this.data.dispatchFailureCodesId = data.value;
        this.saveItem();
    }
    acctClassCBOChanged(data: GItem) {
        this.data.saveCode = "AccountClass";
        this.data.accountClassId = data.value;
        this.saveItem();
    }
    rankChanged(data: any){
        this.data.saveCode = "Rank";
        this.data.rankOrderId = data.dispatchRankOrderId;
        this.saveItem();
    }
    saveItem() {
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.saveDispatchItemQV(this.data).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.saveSuccess(this.data.saveCode);
                this.data.saveCode = null;
            }
            else {
                this.saveError(info.message);
            }
        });
    }

    confirmStatusUpdate(data: ConfirmOutput) {

        if (data.dialogResult === CPDialogResult.ok) {
            this.checkStatusChange(data.data,this.data.dispatchStatusId);
            }
    }
    checkStatusChange(newStatusId: any, existingStatusId: any) {
        let param: CommonParam = new CommonParam();
        param.addParam("newStatusId", newStatusId);
        param.addParam("existingStatusId", existingStatusId);
        param.addParam("dispatchId", this.data.dispatchId);
        CommonFunctions.unsubscribe(this.subs_statusChangeCheck);
        this.subs_statusChangeCheck = this.svc_data.checkDispatchStatusChange(param).subscribe((info: DispatchMessageInfo) => {
            if (info.statusChangeOk === false) {
                let title: string = "Status Change";
                this.miShow("Change Status Warning: " + (info.saveError ? "Error" : "Warning"), info, info, title, null, null);
            }
            else {

                this.saveDispatchStatus(newStatusId);
            }
        });
    }

    confirmAssignmentUpdate(data: ConfirmOutput) {

        if (data.dialogResult === CPDialogResult.ok) {
            this.saveDispatchAssignment(data.data);
        }
    }
    saveDispatchAssignment(data: any) {
        var dispatchAssignmentBus = new DispatchAssignmentBus();
        let dateNow = DateFunctions.getDateNow();
        dispatchAssignmentBus.setNew(this.globals.userId, dateNow, this.globals.companyId, this.globals.personId);
        dispatchAssignmentBus.setParentId(this.data.dispatchId);
        dispatchAssignmentBus.setCommon(this.globals.userId, dateNow, this.globals.companyId, this.globals.personId);
        dispatchAssignmentBus.dispatchAssignmentId = CommonValues.Guid_Empty;
        dispatchAssignmentBus.assignedPersonId = data.techId;
        dispatchAssignmentBus.startDate = data.assignmentDateTime;
        dispatchAssignmentBus.wasCallback = false;
        dispatchAssignmentBus.setBeforeSave();

        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.saveDispatchAssignment(dispatchAssignmentBus).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.pageData.getDispatchTrucks(this.id);
                this.saveSuccess("Assignment Updated");
                if (this.data.dispatchStatusId != CommonValues.Dispatch_Dispatched) {
                    var message = "Would you like to update your status to Dispatched";
                    this.cnfShow(message, CRUDActions.Update, null, "Update Dispatch Status", "UpdateDispatchStatus");
               }
            }
            else {
                this.saveError(info.message);
            }
        });
    }
    saveDispatchStatus(statusId:string) {
        var statusUpdate = new StatusUpdateBus();
        statusUpdate.id = this.data.dispatchId;
        statusUpdate.statusId = statusId;
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.saveDispatchStatus(statusUpdate).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.data.dispatchStatusId = statusId;
                this.data.dispatchStatusName = this.referenceData.getStatus(statusId);
                this.saveSuccess("Status Updated");
                if (info.primaryNumber) {

                    this.cnfDialog.show("There are " + info.primaryNumber + "resources assigned .Would you like to complete out the current resources ?", CRUDActions.Update, info.primaryReturn, "Currently Assigned Resources", "ASGNRES");

                }
            }
            else {
                this.saveError(info.message);
            }
        });
    }
    callbackPersonActive: boolean = false;
    get showCallbackButton(): boolean {
        return this.hasData && CommonFunctions.hasGuidValue(this.data.callbackId);
    }
    showCallbackPerson() {
        this.cd.detectChanges();
        this.pageData.getAssignments(this.data.callbackId, this.referenceData);
        this.callbackPersonActive = true;
    }
    get notClosed(): boolean {
        let can: boolean = false;
        if (!this.data || !this.data.dispatchStatusId || (this.data.dispatchStatusId != CommonValues.Dispatch_Billed && this.data.dispatchStatusId != CommonValues.Dispatch_Closed) || this.rights.EditClosedDispatch) {
            can = true;
        }
        return can;
    }
    get canEditBilledOrClosed(): boolean {
        let can: boolean = true;
        if ((this.data.dispatchStatusId == CommonValues.Dispatch_Billed || this.data.dispatchStatusId == CommonValues.Dispatch_Closed) && !this.rights.EditClosedDispatch) {
            can = false;
        }
        return can;
    }
    closeCallbackPerson(info: BaseMessageInfo) {
        if (info !== null) {
            if (!info.saveError) {
                this.saveSuccess("Callback Person(s) Saved")
                this.addtlData.callbackPerson = info.dcValues.callbackPerson;
            } else {
                this.saveError(info.message);
            }
        }
        this.hideCallbackPerson();
    }
    hideCallbackPerson() {
        this.callbackPersonActive = false;
    }
    doAction(param: CommonParam) {
        let action: string = param.getParam("ACTION");
        let code: string = param.getParam("CODE");
        let id: any = param.getParam("ID");
        switch (action.toUpperCase()) {
            case "GETPAGEDATA":
                this.pageData.getData(id, code);
                break;
        }
    }

    copyDispatchInfoToClipboard(notify: boolean = true) {
        let text: string = this.dispatchBasicInfo;
        CommonFunctions.copyToClipboard(text);
        if (notify) {
            this.globals.notifySuccess("This text Has been copied to the clipboard:  " + text);
        }
    }
    emailDispatchInfo() {
        this.copyDispatchInfoToClipboard(false);
        let subject: string = this.data.customerName + ", " + this.data.locationName + ", WO #" + this.data.woNumber + ", Dispatch #" + this.data.dispatchNumber + " Needs Your Attention!";
        let body: string = this.dispatchBasicInfo;
        window.location.assign("mailto: ?subject=" + subject.replace(/&/g, '%26') + "&body=" + body.replace(/&/g, '%26'));
    }

    get dispatchBasicInfo(): string {
        let text: string = "Dispatch " + this.data.dispatchNumber + " Needs Your Attention!";
        return text;
    }
}
